export default __webpack_public_path__ + "static/media/backtesting.b239fec1.png";